export default __webpack_public_path__ + "static/media/bg-line-left.41a36bd9.svg";